
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductCustomizerPage = lazy(() => import('../pages/product-customizer/page'));
const CollectionsPage = lazy(() => import('../pages/collections/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const WatchCarePage = lazy(() => import('../pages/watch-care/page'));
const ShippingReturnsPage = lazy(() => import('../pages/shipping-returns/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalog',
    element: <CatalogPage />,
  },
  {
    path: '/customizer',
    element: <CollectionsPage />,
  },
  {
    path: '/product-customizer/:watchType',
    element: <ProductCustomizerPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/watch-care',
    element: <WatchCarePage />,
  },
  {
    path: '/shipping-returns',
    element: <ShippingReturnsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
